module.exports = __webpack_public_path__ + "img/logo_yelp_b@3x.17acb01c.png";